import { render, staticRenderFns } from "./nutritionalDistribution.html?vue&type=template&id=d8b1e1ee&scoped=true&"
import script from "./nutritionalDistribution.js?vue&type=script&lang=js&"
export * from "./nutritionalDistribution.js?vue&type=script&lang=js&"
import style0 from "./nutritionalDistribution.scss?vue&type=style&index=0&id=d8b1e1ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b1e1ee",
  null
  
)

export default component.exports